<template>
  <div
    v-if="userData"
    class="dashboard"
  >
    <div class="dashboard-greeting">
      <h1>{{ greeting }}, {{ displayName }}!</h1>
    </div>
    <br-deferral
      v-if="planData.deferrableCertificate && !deferralShown"
      :plan="planData.deferrablePlan"
      :certificate="planData.deferrableCertificate"
      :heading-text="'You have the option to defer maturity for ' + planData.deferrableCertificate.title + ' in the ' + planData.deferrablePlan.planName + '. Please make your selection here.'"
      cancel-text="Skip for now"
      @close="closeDeferral"
    />
    <!-- 11/7/25 Joe: We are showing this dashboard for pro and direct customers -->
    <template v-if="true">
      <div class="selectPlanButtons">
        <template
          v-if="!loadingPlans && activePlans.length && activePlans.length <= 2"
        >
          <p v-if="activePlans.length > 1" style="font-size: 18px;">
            You have {{ activePlans.length }} active plans. Switch between them using the subtabs below to see your individual plan details and values.
          </p>
          <div>
            <button
              v-for="plan in activePlans"
              :key="plan.id"
              class="selectPlanButton"
              :class="{active:selectedPlan?.id == plan.id}"
              @click="selectedPlan = plan"
            >
              {{ plan.name }}
            </button>
          </div>
        </template>
        <p v-if="!loadingPlans && activePlans.length > 2" style="font-size: 18px;">
          You have {{ activePlans.length }} active plans. Switch between them using the dropdown to see your individual plan details and values.
        </p>
        <div v-if="activePlans.length && activePlans.length > 2">
          <select
            v-model="selectedPlan"
          >
            <option
              v-for="plan in activePlans"
              :key="plan.id"
              :value="plan"
            >
              {{ plan.name }}
            </option>
          </select>
        </div>
      </div>
      <!-- Messages/Alerts -->
      <div
        v-if="portalMessage && portalMessage.content"
        class="messages"
      >
        <!-- TODO: refactor into separate component -->
        <div class="message-card">
          <div class="message-header">
            <!-- Icon Slot -->
            <div class="message-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              ><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" /></svg>
            </div>

            <!-- Title Slot -->
            <p
              v-if="portalMessage.subject"
              class="message-title"
            >
              {{ portalMessage.subject }}
            </p>
            <p
              v-else
              class="message-title"
            >
              Message
            </p>
          </div>
          <div class="message-content">
            <!-- Message Slot -->
            <p>{{ portalMessage.content }}</p>
          </div>
        </div>
      </div>

      <div class="diy-dashboard">
        <!-- Welcome -->
        <!-- <section class="welcome-section">
          <h1>Welcome to MyVisionLink Rewards</h1>
          <p>This site is dedicated to helping you understand how your plan works, review your awards and forecasts and to get current up-to-date plan information.<br>We recommend you watch the explanatory video below to learn how the plan operates and to discover how to navigate the site.</p>
        </section> -->
        <div v-if="!loadingPlans && !activePlans.length">
          <h2>Your plan hasn't been activated yet</h2>
          <p>
            There's nothing to view right now, but we'll notify you by email as soon as your plan becomes active.
            Once it's activated, you'll be able to track your forecasted award values and view plan-specific details.
          </p>
        </div>
        <div v-show="statementMatchesPlan">
          <div class="video-and-progress">
            <div v-show="loading.launchVideo[selectedPlan?.id] == false && (selectedLaunchVideo?.src || (clientIsDiy && selectedPlanVideo))" class="videos-container">
              <video
                ref="launchVideoPlayer"
                class="launch-video-player"
                :style="!selectedLaunchVideo?.src ? 'display: none' : ''"
                preload="none"
                controls
              >Your browser does not support the video tag.</video>
              <section
                v-if="loading.launchVideo[selectedPlan?.id] == false && !selectedLaunchVideo?.src && selectedPlanVideo" 
                :key="selectedPlanVideo.video_id"
              >
                <div
                  class="wistia_responsive_padding"
                  style="padding:56.25% 0 0 0;position:relative;"
                >
                  <div
                    class="wistia_responsive_wrapper"
                    style="height:100%;left:0;position:absolute;top:0;width:100%;"
                  >
                    <iframe
                      :src="`https://fast.wistia.net/embed/iframe/${selectedPlanVideo.video_id}?seo=false&videoFoam=true`"
                      :title="selectedPlanVideo.title"
                      allow="autoplay; fullscreen"
                      allowtransparency="true"
                      frameborder="0"
                      scrolling="no"
                      class="wistia_embed"
                      name="wistia_embed"
                      msallowfullscreen
                      width="100%"
                      height="100%"
                    />
                  </div>
                </div>
                <template v-if="selectedPlanVideo.link">
                  <a :href="`${ selectedPlanVideo.link }`">Download</a>
                </template>
              </section>
            </div>
            <ShortTermPlanProgress
              v-if="statementMatchesPlan && selectedPlan.type == 'stip'"
              :key="`progress-${selectedPlan.id}`"
              :statement="selectedStatement"
            />
          </div>
          <template v-if="statementMatchesPlan">
            <template v-if="selectedPlan.type == 'stip'">
              <ShortTermPlanView
                v-if="selectedPlan.statement_version"
                :key="`plan-${selectedPlan.id}`"
                :plan="selectedStatement"
              />
              <LegacyShortTermPlanView
                v-if="!selectedPlan.statement_version"
                :key="`plan-${selectedPlan.id}`"
                :plan="selectedStatement"
              />
            </template>
            <template v-if="selectedPlan.type == 'ltip'">
              <div v-if="loading.certificates[selectedPlan.id]">Loading...</div>
              <AcceptCertificate 
                v-else-if="pendingCertificates[selectedPlan.id] && pendingCertificates[selectedPlan.id].length"
                :key="`certificate-${pendingCertificates[selectedPlan.id][0]}`"
                :certificate="pendingCertificates[selectedPlan.id][0]"
                @get-pending-certificates="getPendingCertificates(selectedPlan)"
              />
              <LongTermPlanView
                v-else
                :key="`plan-${selectedPlan.id}`"
                :plan="selectedStatement"
              />
            </template>
            <AllocationPoolView
              v-if="selectedPlan.type == 'cap' && selectedStatement.current.summary_data.plan.funding_type == 'allocation-pool'"
              :key="`plan-${selectedPlan.id}`"
              :plan="selectedStatement"
              :certificates="selectedStatement.certificates"
            />
            <CashAccountPlanView
              v-if="selectedPlan.type == 'cap' && selectedStatement.current.summary_data.plan.funding_type != 'allocation-pool'"
              :key="`plan-${selectedPlan.id}`"
              :plan="selectedStatement"
              :certificates="selectedStatement.certificates"
            />
          </template>
        </div>
      </div>
    </template>
    <!-- 11/7/25 Joe: The pro dashboard is no longer in use -->
    <template v-else>
      <div
        class="dashboard-sections"
        :class="{'dashboard-sections_noplan':!canShowPlan}"
      >
        <div class="dashboard-sections-dash">
          <h3>My {{ currentYear }} Plans</h3>
          <div class="dashboard-sections-dash-short">
            <!--						<br-card v-if="$dataDirectory.shortTermAvailable" :orange="true">-->
            <!--							<h3>Short-Term Plans (forecasted award)</h3>-->
            <!--							<br-dollars>{{ $accounting.formatCents(planData.shortTerm) }}</br-dollars>-->
            <!--						</br-card>-->
            <!--						<br-card v-if="$dataDirectory.longTermAvailable" :blue="true">-->
            <!--							<h3>Total Plan Value</h3>-->
            <!--							<br-dollars>{{ $accounting.formatCents(planData.longTerm) }}</br-dollars>-->
            <!--						</br-card>-->
          </div>
          <template v-if="canShowFuture">
            <h3 style="display: inline-block">
              My Future: {{ planData.futureYear }}
            </h3>
            <h3 style="float:right;">
              Values are hypothetical
            </h3>
            <div class="dashboard-sections-dash-future">
              <br-card class="uk-margin-small-bottom">
                <div class="dashboard-sections-dash-future-accumulation">
                  <h3>Accumulation Program</h3>
                  <div v-if="canShowTotalLtip">
                    <h3>Forecasted Plan Value (EOY)</h3>
                    <br-dollars>{{ $accounting.formatCents(planData.totalLTIP) }}</br-dollars>
                  </div>
                  <div v-if="planData.conventionalEvs">
                    <h3>Total Wealth Projection</h3>
                    <br-dollars>{{ $accounting.formatCents(planData.totalWealth) }}</br-dollars>
                  </div>
                </div>
              </br-card>
              <br-card v-if="planData.conventionalEvs">
                <div class="dashboard-sections-dash-future-charts">
                  <div class="dashboard-sections-dash-future-charts-annual">
                    <h3>Annual Income</h3>
                    <div class="chart">
                      <div class="uk-text-center">
                        <br-dollars>{{ $accounting.formatCents(planData.annualIncome) }}</br-dollars> <br>
                        <span>Total Annual Income</span>
                      </div>
                      <pie-chart
                        :chartdata="pieChartData"
                        :options="{
                          legend: {
                            display: false
                          },
                          tooltips: {
                            enabled: false
                          }
                        }"
                      />
                    </div>
                    <div class="legend">
                      <div
                        v-if="annualValues[0]"
                        class="legend-row"
                      >
                        <div class="square square-salary" />
                        <div>Salary</div>
                        <br-dollars>{{ $accounting.formatCents(annualValues[0]) }}</br-dollars>
                      </div>
                      <div
                        v-if="annualValues[1]"
                        class="legend-row"
                      >
                        <div class="square square-short" />
                        <div>Short-Term Award</div>
                        <br-dollars>{{ $accounting.formatCents(annualValues[1]) }}</br-dollars>
                      </div>
                      <div
                        v-if="annualValues[2]"
                        class="legend-row"
                      >
                        <div class="square square-long" />
                        <div>Long-Term Award</div>
                        <br-dollars>{{ $accounting.formatCents(annualValues[2]) }}</br-dollars>
                      </div>
                    </div>
                  </div>
                  <div class="dashboard-sections-dash-future-charts-cumulative">
                    <h3>Cumulative Income</h3>
                    <div class="uk-text-center">
                      <br-dollars>{{ $accounting.formatCents(planData.totalIncome) }}</br-dollars> <br>
                      <span>Total Cumulative Income</span>
                    </div>
                    <percentage-bar :data-values="cumulativeValues" />
                    <div class="legend">
                      <div
                        v-if="cumulativeValues[0]"
                        class="legend-row"
                      >
                        <div class="square square-salary" />
                        <div>Total Salaries</div>
                        <br-dollars>{{ $accounting.formatCents(cumulativeValues[0]) }}</br-dollars>
                      </div>
                      <div
                        v-if="cumulativeValues[1]"
                        class="legend-row"
                      >
                        <div class="square square-short" />
                        <div>Short-Term Award</div>
                        <br-dollars>{{ $accounting.formatCents(cumulativeValues[1]) }}</br-dollars>
                      </div>
                      <div
                        v-if="cumulativeValues[2]"
                        class="legend-row"
                      >
                        <div class="square square-long" />
                        <div>Long-Term Award</div>
                        <br-dollars>{{ $accounting.formatCents(cumulativeValues[2]) }}</br-dollars>
                      </div>
                    </div>
                  </div>
                </div>
              </br-card>
            </div>
          </template>
        </div>
        <br-messages />
      </div>
    </template>

    <va-modal
      v-if="showErrorMessage"
      v-model="showErrorMessage"
      title="Communication Error"
      close-button
    >
      <div>
        <p>There was an error connecting to the server.</p>
        <p>We were unable to obtain the data for this page at this time. Please try again later.</p>
      </div>
    </va-modal>

    <!-- <div v-if="apiLoginDesc">
      {{ apiLoginDesc }}
    </div> -->
  </div>
</template>

<script>
import BrCard from "@/components/elements/BrCard";
import BrDeferral from "@/components/elements/BrDeferral";
import BrDollars from "@/components/elements/BrDollars";
import BrMessages from "@/components/elements/BrMessages";
import PieChart from "@/components/charts/PieChart";
import PercentageBar from "@/components/charts/PercentageBar";
import UnifiedApiManager from "@/classes/UnifiedApiManager";
import ShortTermPlanView from '@/components/pages/ShortTermPlanView.vue';
import LegacyShortTermPlanView from '@/components/pages/LegacyShortTermPlanView.vue';
import LongTermPlanView from '@/components/pages/LongTermPlanView.vue';
import AllocationPoolView from '@/components/pages/AllocationPoolView.vue';
import CashAccountPlanView from '@/components/pages/CashAccountPlanView.vue';
import ShortTermPlanProgress from "@/components/plans/short-term/PlanProgress.vue";
import AcceptCertificate from "@/components/pages/AcceptCertificate.vue";
export default {
	name: "BrDashboard",

	components: {
		BrCard,
		BrDeferral,
		BrDollars,
		BrMessages,
		PieChart,
		PercentageBar,
    ShortTermPlanView,
    LegacyShortTermPlanView,
    LongTermPlanView,
    AllocationPoolView,
    CashAccountPlanView,
    ShortTermPlanProgress,
    AcceptCertificate,
	},

  beforeRouteLeave() {
    // ensure the launch video is not loading
    const video = this.$refs['launchVideoPlayer'];
    if (video) {
      video.src = '';
      video.load();
    }
  },

	data() {
		return {
			apiLoginInfo: null,
			loading: {
				portal_message: false,
				video: false,
        stipList: false,
        ltipList: false,
        capList: false,
        launchVideo: {},
        certificates: {},
			},
      userData: null,
			planData: {
				annualIncome: 0,
				annualLongAward: 0,
				annualSalary: 0,
				annualShortAward: 0,
				evsAvailable: false,
				conventionalEvs: false,
				futureYear: 0,
				longTerm: 0,
				ltipCount: 0,
				shortTerm: 0,
				stipCount: 0,
				cashAccount: 0,
				capCount: 0,
				success: true,
				totalIncome: 0,
				totalLTIP: 0,
				totalLongAwards: 0,
				totalSalary: 0,
				totalShortAwards: 0,
				totalWealth: 0,
			},
			annualValues: [
				0,
				0,
				0
			],
			cumulativeValues: [
				0,
				0,
				0
			],
			pieChartData: {
				hoverBorderWidth: 10,
				labels: ["Salary", "Short-Term Award", "Long-Term Award"],
				datasets: [
					{
						label: 'Data One',
						backgroundColor: ['#87C426','#FF9800','#71C4BC'],
						data: []
					}
				]
			},
			showErrorMessage: false,
			deferralShown: false,
			portalMessage: null,
			planVideos: null, // pre-made videos for Direct clients
      launchVideos: {}, // videos published from Pro
			stipList: [],
			ltipList: [],
			capList: [],
      activePlans: [],
      planStatements: {},
      selectedPlan: null,
      pendingCertificates: {},
		}
	},

	computed:{
    loadingPlans() {
      return this.loading.stipList || this.loading.ltipList || this.loading.capList; 
    },
		apiLoginDesc() {
			return this.apiLoginInfo && this.apiLoginInfo.env_code != 'prod' ? 
				`API login info: user-${this.apiLoginInfo.display_name}, company name-${this.apiLoginInfo.company_name}` :
				'';
		},
    selectedStatement() {
      return this.planStatements[this.selectedPlan?.id] ?? null;
    },
    statementMatchesPlan() {
      return (this.selectedStatement?.current.summary_data && (this.selectedStatement?.current.summary_data.plan_id == this.selectedPlan?.id || this.selectedStatement?.current.summary_data.plan?.id == this.selectedPlan?.id))
        || (this.selectedStatement?.current.statement_data && this.selectedStatement?.current.statement_data.plan.id == this.selectedPlan?.id);
    },
		clientIsDiy() {
			return this.$dataDirectory.userData.client_status === 'diy' || this.$dataDirectory.userData.client_status === 'DIY';
		},
		greeting() {
			let current_hour = new Date().getHours();

			if(current_hour < 12){
				return "Good Morning";
			}
			else if(current_hour < 18){
				return "Good Afternoon";
			}
			else {
				return "Welcome";
			}
		},

		canShowPlan(){
			return this.planData.stipCount > 0 || this.planData.ltipCount > 0 || this.planData.capCount > 0;
		},
		canShowFuture(){
			return this.planData.totalIncome && this.planData.totalIncome > 0;
		},
		canShowTotalLtip(){
			return this.planData.ltipCount > 0;
		},
		displayName(){
			if(/\s/.test(this.userData.firstName.trim())){
				return this.userData.firstName + " " + this.userData.lastName;
			}
			return this.userData.firstName;
		},
		currentYear(){
			let date = new Date();
			return date.getFullYear();
		},
    selectedLaunchVideo() {
      return this.launchVideos[this.selectedPlan?.id];
    },
    selectedPlanVideo() {
      return this.videos.find((video) => video.plan_name == this.selectedPlan.name);
    },
    videos() {
      if(this.planVideos?.length) return this.planVideos
      else return []
    },
	},

	watch:{
    activePlans:{
      deep: true,
      handler(){
        // select the dpsp if available, otherwise select the first plan in the list
        if (this.planData.deferrablePlan && this.activePlans.find((plan) => plan.name == this.planData.deferrablePlan.planName)) {
          this.selectedPlan = this.activePlans.find((plan) => plan.name == this.planData.deferrablePlan.planName);
        } else {
          this.selectedPlan = this.activePlans[0];
        }
      }
    },
    selectedPlan:{
      handler() {
        // when selecting a plan, set the video src if we have it
        console.log('selected plan %s, %ssrc %s', this.selectedPlan?.id ?? 'null', this.selectedLaunchVideo?.src && this.$refs.launchVideoPlayer.src != this.selectedLaunchVideo.src ? 'set ' : '', this.selectedLaunchVideo?.src ?? 'null');
        if (this.selectedLaunchVideo?.src && this.$refs.launchVideoPlayer?.src != this.selectedLaunchVideo.src) {
          this.$refs.launchVideoPlayer.src = this.selectedLaunchVideo.src;
          this.$refs.launchVideoPlayer.load();
        }
      }
    },
    'loading.launchVideo':{
      deep: true,
      handler(newVal) {
        // when a launch video loads for the selected plan, set the video src
        if (!newVal[this.selectedPlan.id] && this.selectedLaunchVideo?.src && this.$refs.launchVideoPlayer?.src != this.selectedLaunchVideo.src) {
          this.$refs.launchVideoPlayer.src = this.selectedLaunchVideo.src;
          this.$refs.launchVideoPlayer.load();
          console.log('plan %s video loaded, set src %s', this.selectedPlan?.id ?? 'null', this.selectedLaunchVideo?.src ?? 'null');
        }
      }
    },
    statementMatchesPlan:{
      handler(newVal) {
        console.log('statement %s, %slaunch video src %s', newVal ? 'loaded' : 'loading', this.selectedLaunchVideo?.src ? 'set ' : '', this.selectedLaunchVideo?.src ?? 'null');
        if (newVal && this.selectedLaunchVideo?.src && this.$refs.launchVideoPlayer?.src != this.selectedLaunchVideo.src) {
          this.$refs.launchVideoPlayer.src = this.selectedLaunchVideo.src;
          this.$refs.launchVideoPlayer.load();
        }
      }
    },
	},

	mounted() {
		this.init();
		this.getLatestPortalMessage();
	},

	methods: {
		init(){
      // ensure our session is valid and userData is initialized
			this.$dataDirectory.checkLogin(
				() => this.userData = this.$dataDirectory.userData,
				() => this.$router.push("/login")
			);
			this.pieChartData.datasets[0].data = this.annualValues;

			this.$dataDirectory.wasPostingFutureYear = this.$dataDirectory.isPostingFutureYear;
			this.$apiManager.get("plans").then(
				(pack) => this.planDataSuccess(pack),
				() => this.planDataFailure()
			);
      // Get list of each active plan type and load all plan accessories
      this.loading.stipList = true;
			this.$apiManager.get("plans/stip-list").then(
        (pack) => this.stipListSuccess(pack),
				() => {
          this.loading.stipList = false;
          this.planDataFailure()
        }
			);
      this.loading.ltipList = true;
			this.$apiManager.get("plans/ltip-list").then(
        (pack) => this.ltipListSuccess(pack),
				() => {
          this.loading.ltipList = false;
          this.planDataFailure()
        }
			);
      this.loading.capList = true;
			this.$apiManager.get("plans/cap-list").then(
        (pack) => this.capListSuccess(pack),
				() => {
          this.loading.capList = false;
          this.planDataFailure()
        }
			);
			let api = new UnifiedApiManager();
			this.apiLoginInfo = api.loginInfo;
		},
    /** here we are just getting the video meta (type) and src to set on the element, which does the actual loading */
    getLaunchVideo(plan) {
      // if we already have the video, skip fetching metadata
      if (!this.launchVideos[plan.id]?.src) {
        this.loading.launchVideo[plan.id] = true;
        fetch(this.$apiManager.route("launch-video-meta/" + plan.id), {responseType: 'application/json', credentials: 'include'}).then(
          (pack) => {
            // success response will be json
            if (pack.headers.get('content-type') == 'application/json') {
              pack.json().then((data) => {
                if (data.success) {
                  // set video metadata
                  this.launchVideos[plan.id] = {
                    src: this.$apiManager.route("launch-video/" + plan.id),
                    type: data.type,
                  };
                  this.loading.launchVideo[plan.id] = false;
                } else {
                  console.error(data);
                  this.loading.launchVideo[plan.id] = false;
                }
              });
            } else {
              console.error('failed to get launch video metadata');
              this.loading.launchVideo[plan.id] = false;
            }
          },
          (err) => {
            console.error(err);
            this.loading.launchVideo[plan.id] = false;
          }
        )
      }
    },
    getStatement(plan) {
      this.$apiManager.get(`plans/${plan.type}/${plan.id}`)
        .then((result) => {
          this.planStatements[plan.id] = result.data;
        })
        .catch((error) => {
          console.error(error)
        });
    },
    getPendingCertificates(plan) {
      if (!['diy', 'DIY'].includes(this.$dataDirectory.userData.client_status)) {
        this.loading.certificates[plan.id] = false;
        return;
      }
      this.loading.certificates[plan.id] = true;
      this.$apiManager.get(`certificate/pending/${plan.id}`)
          .then((result) => {
            this.pendingCertificates[plan.id] = result.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading.certificates[plan.id] = false;
          });
    },
		stipListSuccess (pack) {
      this.loading.stipList = false;
			Object.values(pack.data.plans).forEach((plan) => {
        let planWithType = {...plan, type: 'stip'};
        this.stipList.push(planWithType);
        if (!plan.finalized) {
          this.activePlans.push(planWithType);
          this.getStatement(planWithType);
          this.getLaunchVideo(planWithType);
        }
      });
		},
		ltipListSuccess (pack) {
      this.loading.ltipList = false;
			Object.values(pack.data.plans).forEach((plan) => {
        let planWithType = {...plan, type: 'ltip'};
        this.ltipList.push(planWithType);
        if (!plan.finalized) {
          this.activePlans.push(planWithType);
          this.getStatement(planWithType);
          this.getPendingCertificates(planWithType);
          this.getLaunchVideo(planWithType);
        }
      });
		},
		capListSuccess (pack) {
      this.loading.capList = false;
			Object.values(pack.data.plans).forEach((plan) => {
        let planWithType = {...plan, type: 'cap'};
        this.capList.push(planWithType);
        if (!plan.finalized) {
          this.activePlans.push(planWithType);
          this.getStatement(planWithType);
          this.getLaunchVideo(planWithType);
        }
      });
		},
		planDataSuccess(pack){
      console.log(pack.data)

			if(pack.data.success){
				this.planData = pack.data;
				this.annualValues = [
					this.planData.annualSalary,
					this.planData.annualShortAward,
					this.planData.annualLongAward
				];

				this.cumulativeValues = [
					this.planData.totalSalary,
					this.planData.totalShortAwards,
					this.planData.totalLongAwards
				];
				this.pieChartData.datasets[0].data = this.annualValues;
				this.$dataDirectory.evsAvailable = this.planData.evsAvailable;
				this.$dataDirectory.conventionalEvs = this.planData.conventionalEvs;
				this.$dataDirectory.shortTermAvailable = this.planData.stipCount && this.planData.stipCount > 0;
				this.$dataDirectory.longTermAvailable = this.planData.ltipCount && this.planData.ltipCount > 0;
				this.$dataDirectory.cashAccountAvailable = this.planData.capCount && this.planData.capCount > 0;
				if (this.$dataDirectory.wasPostingFutureYear) {
					this.planData.futureYear = this.$dataDirectory.futureYear;
				} else {
					this.$dataDirectory.futureYear = this.planData.futureYear;
				}
				this.$dataDirectory.planUpdated = true;

        if(this.clientIsDiy) this.getPlanVideos()
			}
		},
		planDataFailure(){
			this.showErrorMessage = true;
		},

    getLatestPortalMessage() {
        this.loading.portal_message = true
        this.$apiManager.get('portal-message')
            .then((result) => {
                if(result.data?.success) this.portalMessage = result.data.message
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                this.loading.portal_message = false
            })
    },
    getPlanVideos() {
      this.loading.video = true
      this.$apiManager.get(`plan-videos`)
          .then((result) => {
              if(result.data?.videos) this.planVideos = Object.values(result.data.videos)
          })
          .catch((error) => {
              console.error(error)
          })
          .finally(() => {
              this.loading.video = false
          })
    },

		messageCardClass(message) {
			console.log(message);
			return true
		},
		closeDeferral() {
			this.deferralShown = true;
		},
	}
}
</script>

<style lang="scss" scoped>
@use "../../scss/_variables.scss";

	.messages {
		margin-bottom: 2em;

		.message-card {
			width: 100%;

			padding: 2em 2.5em;

			// Alert
			//background-color: #FF98000D;
			//border:1px solid #FF9800;

			// Message/Info
			background-color: rgba(6, 80, 136, 0.2);
			border:1px solid #065088;

			border-radius: 10px;

			font-size: variables.$text-sm;

			.message-header {
				display: flex;
				align-items: center;
				margin-bottom: 1em;

				.message-icon {
					margin-right: 1em;

					svg {
						fill: #065088;

						width: 2em;
						height: 2em;
					}
				}
				.message-title {
					font-size: variables.$text-base;
					font-weight: 700;
				}
			}
			.message-content {}
		}
	}

	.dashboard-greeting {
		display: flex;
		justify-content: space-between;
		margin-bottom: 1vw;

		h1{
			margin-bottom: 0px;
      font-size: variables.$text-md;
		}

		h2 {
			font-size: variables.$text-lg;
			text-transform: uppercase;
		}
		p {
			font-size: variables.$text-lg;
			font-weight: 700;
			text-transform: uppercase;
		}
	}

	.diy-dashboard {
		.welcome-section {
			margin-bottom: 3em;

			h1 {
				margin-bottom: 0.25em;
			}

      p:last-child {
        margin-top: 2em;
      }
		}

    .videos-container {
      width: 100%;
      @media screen and (min-width: 851px) {
        width: 49%;
      }
    }

    .launch-video-player {
      max-width: 100%;
      max-height: 472px;
    }
    .video-and-progress {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1rem;
      @media screen and (max-width: 850px){
        flex-direction: column;
        gap: 8px;
      }
    }

	}

	.dashboard-sections{
		display: grid;
		grid-template-columns: auto 260px;

		&-dash{
			padding-right: 2vw;
			margin-right: 2vw;
			border-right: thin solid rgba(#1F3A4D, 0.25);
			&-short{
				display: grid;
				grid-template-columns: 48% 48%;
				grid-column-gap: 4%;
				padding-bottom: 2vw;
				margin-bottom: 2vw;
				border-bottom: thin solid rgba(#1F3A4D, 0.25);
				h3{
					color: variables.$color-text-secondary;
				}
			}
			&-future{
				h3{
					color: variables.$color-text-secondary;
				}
				&-accumulation{
					display: grid;
					grid-template-columns: 15% 36% 36%;
					grid-column-gap: 5%;
					&>div{
						background-color: variables.$color-background-tertiary;
						border-radius: 15px;
						padding: 1vw 1.5vw;
					}
				}
				&-charts{
					display: grid;
					grid-template-columns: 47% 48%;
					grid-column-gap: 5%;
					.dollar-field{
						font-size: 20px;
					}

					&-annual{
						.chart{
							grid-template-columns: 120px auto;
							margin-top: -20px;
							margin-bottom: 15px;

							.uk-text-center{
								padding-top: 20px;
							}
						}
					}

					&-cumulative{
						.percentage-bar{
							margin-top: 20px;
							margin-bottom: 40px;
						}
					}

					.legend{

						&-row{
							display: grid;
							grid-template-columns: 24px auto 25%;
							grid-column-gap: 4%;
							font-size: 13px;
							margin-bottom: 8px;
							.dollar-field{
								font-size: 13px;
							}
						}
						.square{
							background-color: black;
							width: 24px;
							height: 24px;

							&-salary{
								background-color: variables.$color-card-border-green;
							}
							&-short{
								background-color: variables.$color-card-border-orange;
							}
							&-long{
								background-color: variables.$color-card-border-blue;
							}
						}
					}
				}
			}
		}

		&_noplan{
			display: block;
			.dashboard-sections-dash{
				display: none;
				border-bottom: thin solid rgba(#1F3A4D, 0.25);
				border-right: none;
				margin-bottom: 25px;
				margin-right: 0;
				padding-bottom: 15px;
				padding-right: 0;
			}
		}

		@media screen and (max-width: 1200px){
			display: block;
			&-dash{
				border-bottom: thin solid rgba(#1F3A4D, 0.25);
				border-right: none;
				margin-bottom: 25px;
				margin-right: 0;
				padding-bottom: 15px;
				padding-right: 0;
			}
		}
	}
  .selectPlanButtons {
    div {
      width: 50%;
      display: flex;
      gap: 4px;
      margin: 0.5rem 0;

      @media screen and (max-width: 850px) {
        width: 100%;
      }
    }

    select {
      font-size: 22px;
      font-weight: bold;
      text-transform: capitalize;
      max-width: 100%;
    }

    option {
      text-transform: capitalize;
    }
  }
  .selectPlanButton {
    text-transform: capitalize;
    font-weight: bold;
    width: -webkit-fill-available;
    padding: 12px;
    color: variables.$color-text-primary;
    background-color: variables.$color-background-primary;
    border: 2px solid variables.$color-text-primary;
    border-radius: 8px;
    &.active {
      color: variables.$color-background-primary;
      background-color: variables.$color-text-primary;
    }
  }
</style>
